// export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
// export const API_BASE = process.env.REACT_APP_API_BASE || process.env.REACT_APP_API_URL || 'http://localhost:3001' || '';
export const API_BASE= '';
export const USERNAME = process.env.REACT_APP_USERNAME || 'admin';
export const PASSWORD = process.env.REACT_APP_PASSWORD || 'Niha@1992';
